import React, { useContext, useEffect, useState, useMemo } from "react"
import { randomBytes } from "crypto"
import PropTypes from "prop-types"
import WeSlider from "./we-slider"
import PhilosophySlider from "./philosophy-slider"
import LocationsSlider from "./locations-slider"
import TeamSlider from "./team-slider"
import CsrSlider from "./csr-slider"
import { ThemeContext } from "../contexts/theme-context"

const AboutSection = ({ navState, lang = "de", dimensions }) => {
  const [activeSlide, setActiveSlide] = useState([1, 1, 1, 1, 1])
  const theme = useContext(ThemeContext)

  useEffect(() => {
    if (theme[0][0] === "dark") theme[1](["light", "full"])
    switch (navState) {
      case "we":
        setActiveSlide([10, 1, 1, 1, 1])
        break
      case "philosophy":
        setActiveSlide([1, 10, 1, 1, 1])
        break
      case "locations":
        setActiveSlide([1, 1, 10, 1, 1])
        break
      case "team":
        setActiveSlide([1, 1, 1, 10, 1])
        break
      case "csr":
        setActiveSlide([1, 1, 1, 1, 10])
        break
      default:
        setActiveSlide([1, 1, 1, 1, 1])
    }
  }, [navState])

  const allHeights = useMemo(() => {
    let checkedInputStyles = ""
    for (let i = 1; i < 6; i++) {
      checkedInputStyles += `
        input[name*="about-nav"]:nth-child(${i}):checked ~ .about-wrapper .about-inner {
          margin-top: ${(i - 1) * -dimensions[1]}px;
        }
      `
    }
    return `
    ${checkedInputStyles}
    .about-wrapper {
          height: ${dimensions[1]}px;
        }
        .about-wrapper .about-inner {
          height: ${dimensions[1] * 5}px;
        }
        .about-wrapper .about-inner .carousel-item {
          height: ${
            dimensions[0] > 640 ? dimensions[1] : dimensions[1] / 2
          }px !important;
        }
        .about-wrapper .about-inner .carousel-item:nth-child(1) {
          height: ${dimensions[0] > 640 ? dimensions[1] : 390}px !important;
        }
        .about-wrapper .about-inner .carousel-item:nth-child(2) {
          height: ${
            dimensions[0] > 640 ? dimensions[1] : dimensions[1] - 390
          }px !important;
        }
      `
  }, [dimensions])

  return (
    <>
      <style key={randomBytes(6).toString("hex")}>{allHeights}</style>
      <div className="about-wrapper">
        {/* Making sure the video's poster is rendered at the right size */}
        <div className="about-inner">
          <WeSlider
            lang={lang}
            activeSlideIndex={activeSlide[0]}
            dimensions={dimensions}
          />
          <PhilosophySlider
            lang={lang}
            radioButtonIdOffset={2}
            activeSlideIndex={activeSlide[1]}
            dimensions={dimensions}
          />
          <LocationsSlider
            lang={lang}
            radioButtonIdOffset={5}
            activeSlideIndex={activeSlide[2]}
            dimensions={dimensions}
          />
          <TeamSlider
            lang={lang}
            radioButtonIdOffset={8}
            activeSlideIndex={activeSlide[3]}
            dimensions={dimensions}
          />
          <CsrSlider
            lang={lang}
            radioButtonIdOffset={10}
            activeSlideIndex={activeSlide[4]}
            dimensions={dimensions}
          />
        </div>
      </div>
    </>
  )
}

AboutSection.propTypes = {
  children: PropTypes.node,
  navState: PropTypes.string,
  lang: PropTypes.string,
  dimensions: PropTypes.array,
}

export default AboutSection
